// CANONICAL COPY (GH #7115). src/constants/obligations/obl-ski-nda-breach-and-termination-process.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-ski-nda-breach-and-termination-process',
  title: 'Ensure NDAs include processes for breach reporting, termination and data destruction',
  description:
    'Non-disclosure agreements with employees working under government framework contracts must include: a process for reporting unauthorised disclosures; a process for handling NDA breaches; conditions for terminating the agreement; and requirements for returning or securely destroying information after the agreement ends.',
  category: 'people',
  scfIds: ['SCF-PPL-002', 'SCF-DAT-001'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    {
      type: 'document-published',
      description: 'NDA template includes breach and termination clauses',
    },
    { type: 'document-approved', description: 'NDA template has been approved' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
